(() => {
  if (window.belaMedicubeReady) return;
  window.belaMedicubeReady = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = document.querySelectorAll('[data-mc-reveal]');

  if (!reducedMotion && 'IntersectionObserver' in window) {
    revealItems.forEach((item) => item.classList.add('mc-is-pending'));

    const observer = new IntersectionObserver(
      (entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove('mc-is-pending');
          entry.target.classList.add('mc-is-visible');
          instance.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8%', threshold: 0.08 }
    );

    revealItems.forEach((item) => observer.observe(item));
  }

  const heroMedia = document.querySelector('[data-mc-parallax]');
  const canAnimate = !reducedMotion && window.matchMedia('(pointer: fine)').matches;

  if (heroMedia && canAnimate) {
    let scheduled = false;

    const updateParallax = () => {
      const offset = Math.min(window.scrollY * 0.045, 38);
      heroMedia.style.transform = `translate3d(0, ${offset}px, 0)`;
      scheduled = false;
    };

    window.addEventListener('scroll', () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(updateParallax);
    }, { passive: true });
  }

  function initFormulaStage(section) {
    if (!section || section.dataset.mcFormulaReady === 'true') return;
    section.dataset.mcFormulaReady = 'true';
    const stage = section.querySelector('[data-mc-egf-stage]');
    const svg = section.querySelector('[data-mc-egf-lines]');
    const product = section.querySelector('.mc-egf__product');
    const cards = section.querySelectorAll('[data-mc-egf-callout]');
    if (!stage || !svg || !product || !cards.length) return;

    const draw = () => {
      const stageRect = stage.getBoundingClientRect();
      const productRect = product.getBoundingClientRect();
      if (!stageRect.width || !productRect.width) return;
      svg.setAttribute('viewBox', `0 0 ${stage.clientWidth} ${stage.clientHeight}`);
      const isMobile = window.innerWidth <= 749;
      cards.forEach((card) => {
        const id = card.dataset.mcEgfCallout;
        const zone = card.dataset.mcEgfZone;
        const anchor = card.querySelector('[data-mc-egf-anchor]');
        const line = svg.querySelector(`[data-mc-egf-line="${id}"]`);
        const dot = svg.querySelector(`[data-mc-egf-dot="${id}"]`);
        if (!anchor || !line || !dot) return;
        const anchorRect = anchor.getBoundingClientRect();
        const startX = anchorRect.left - stageRect.left + anchorRect.width / 2;
        const startY = anchorRect.top - stageRect.top + anchorRect.height / 2;
        const productX = productRect.left - stageRect.left;
        const productY = productRect.top - stageRect.top;
        const left = zone === 'tl' || zone === 'bl';
        const top = zone === 'tl' || zone === 'tr';
        const endX = productX + productRect.width * (left ? .28 : .72);
        const endY = productY + productRect.height * (top ? .32 : .7);
        const path = isMobile
          ? `M ${startX} ${startY} V ${top ? endY - 32 : endY + 32} H ${endX} V ${endY}`
          : `M ${startX} ${startY} H ${left ? endX - 58 : endX + 58} V ${endY} H ${endX}`;
        line.setAttribute('d', path);
        dot.setAttribute('cx', endX);
        dot.setAttribute('cy', endY);
      });
    };
    if (product.complete) draw(); else product.addEventListener('load', draw, { once: true });
    window.addEventListener('resize', draw, { passive: true });
    window.setTimeout(draw, 300);
  }

  document.querySelectorAll('[data-mc-egf]').forEach(initFormulaStage);
})();
